import { dateFormatter, useTranslation, parseTemperature } from '@fareye/common'
import { Flex, layout, styled, PopOver, Label } from '@fareye/ui'
import {
  capitalize,
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryQuarter,
  FaBatteryThreeQuarters,
  FaExclamationTriangle,
  isEmpty,
  startCase,
  subDays,
  toTileCase,
  MdMessage,
  MdArrowDropDown,
  FiInfo,
  ModeAir,
  ModeRail,
  ModeOcean,
  ModeRoad
} from '@fareye/utils'
import {
  MdSignalCellularOff,
  MdSignalCellularConnectedNoInternet4Bar,
  MdSignalCellular4Bar,
  MdBatteryFull,
  MdBatteryAlert,
  MdBatteryUnknown,
  getValueFromNestedKey,
  GoPrimitiveDot,
  FaCheckCircle
} from '@fareye/utils'
import { getRunningStatusObj } from '../../../utility/funcs'
import React from 'react'
import MultiModelStoryLine from '../../../components/MultiModelStoryLine'
import {
  BoldText,
  LandmarkText,
  Link,
  Span
} from '../../../components/Timeline/styled'
import { formatters } from '../../../config/constants'
import { ColorSpan } from '../../../style/styled'
import { IColumn } from '../../../utility/types'
import CarrierPopover from './Carrier'
import VehiclePopover from './VehiclesPopover'
import DeviceDetails from './DeviceDetails'
const Svg: any = {
  air: ModeAir,
  ocean: ModeOcean,
  road: ModeRoad,
  rail: ModeRail
}
const BgSpan = styled(Span)`
  background: ${props =>
    props.theme.colors[props?.title] || 'rgba(98,90,80,1)'};
  width: min-content;
`

const CheckBox = styled.span`
  margin-left: 5px;
  height: 14px;
  width: 14px;
  border: 1px solid green;
  background: green;
  color: white;
  text-align: center;
`

function InfoIcons(props: any) {
  const bodyStyle = {
    color: 'black',
    background: '#F9E5E7',
    marginBottom: '-5px',
    boxShadow: '0px 10px 8px rgba(0, 0, 0, 0.24)',
    padding: '10px 8px',
    lineHeight: '18px',
    fontSize: '12px'
  }
  const infoIconStyle = { marginTop: '3px', marginRight: '2px' }
  return (
    <PopOver variant="arrow hover Bottom-Left">
      <FiInfo size={15} color="#C84031" style={infoIconStyle} />

      <PopOver.Body
        style={{
          body: bodyStyle,
          arrow: {
            background: '#F9E5E7'
          }
        }}
        variant="arrow hover"
      >
        We are unable to provide Arrival and <br></br>
        Departure for Stops coming in consecutive <br></br>
        sequence with same addresses or Location codes <br></br>
      </PopOver.Body>
    </PopOver>
  )
}

function DropDownPopOver(props: any) {
  const { list, textToDisplay, boldTextStyle } = props
  if (list && list.length >= 1) {
    return (
      <PopOver style={{ margin: '0 10px' }} variant="arrow Bottom-Left">
        <BoldText
          {...boldTextStyle}
          style={{
            fontSize: '14px !important',
            fontWeight: 'normal',
            lineHeight: '22px'
          }}
        >
          {textToDisplay || '-'}
        </BoldText>
        <MdArrowDropDown
          size={20}
          style={{
            position: 'relative',
            top: '2px',
            color: '#727272'
          }}
        />
        <br />
        <PopOver.Body>
          {list.map((item: any, n: any) => (
            <Flex column>
              <Label>{item.name}</Label>
            </Flex>
          ))}
        </PopOver.Body>
      </PopOver>
    )
  }
  return (
    <BoldText
      {...boldTextStyle}
      style={{
        fontSize: '14px !important',
        fontWeight: 'normal',
        lineHeight: '22px'
      }}
    >
      {textToDisplay || '-'}
    </BoldText>
  )
}
function PoNumberDropDown(props: any) {
  const { list } = props
  if (list && list.length > 0) {
    return (
      <PopOver style={{ margin: '0 10px' }} variant="arrow Bottom-Left">
        <Span>{list[0].name} </Span>
        <Span
          style={{
            padding: '1px 0px',
            borderRadius: 4,
            backgroundColor: '#E5F6FF',
            color: '#1276D3',
            fontSize: '10px'
          }}
        >
          {list.length > 0 && '+' + list.length + 'More '}
        </Span>
        <PopOver.Body>
          {list.map((item: any, n: any) => (
            <Flex column>
              <Label>{item.name}</Label>
            </Flex>
          ))}
        </PopOver.Body>
      </PopOver>
    )
  }
  return <br />
}
const Badge = styled(Span)`
position:relative;     
&:after {
  position:absolute;
  min-width:10px;
  min-height:10px;
  line-height:10px;
  padding:2px;
  color:#fff;
  background-color:#bf1f1f;
  font-size:10px;
  border-radius:20px;
  content:attr(data-badge);
  text-align: center;
  box-sizing:content-box;
  border:solid 1px #c93a3a;`
interface IHeader {
  align?: 'left' | 'right' | 'center'
}

const SidePanelContainer = styled(Flex)`
  background-color: #f3f3f3;
  position: relative;
  right: -5px;
  height: 59px;
  margin-right: 2px;
  margin-left: auto;
  margin-top: -13px;
  margin-bottom: -15px;
  width: 50px;
  padding: 25px 0 15px 0;
  box-sizing: content-box;
`
function SidePanel(props: any) {
  const {
    issuesRaisedCount,
    exceptionCount,
    linkToIssueRaised,
    linkToExceptionRaised
  } = props
  return (
    <SidePanelContainer column>
      <Link target="_blank" variant="xs" to={linkToExceptionRaised}>
        <Flex>
          <Span
            style={{
              backgroundColor: '#F3F3F3',
              marginLeft: '14px',
              marginTop: '-12px'
            }}
            mb={6}
          >
            <FaExclamationTriangle size={18} color="#727272" />
          </Span>

          {exceptionCount > 0 && (
            <Badge
              ml={5}
              data-badge={exceptionCount}
              style={{ right: '20px', top: '-5px', marginTop: '-12px' }}
            />
          )}
        </Flex>
      </Link>
      <Link target="_blank" variant="xs" to={linkToIssueRaised}>
        <Flex>
          <Span style={{ backgroundColor: '#F3F3F3', marginLeft: '14px' }}>
            <MdMessage size={18} color="#727272" />
          </Span>
          {issuesRaisedCount > 0 && (
            <Badge
              ml={5}
              data-badge={issuesRaisedCount}
              style={{ right: '20px', top: '-5px' }}
            />
          )}
        </Flex>
      </Link>
    </SidePanelContainer>
  )
}

function DeviceUnkown(props: any) {
  const { t } = useTranslation()
  return (
    <Flex alignItemsCenter>
      <Span mr={4} ml={-1} title={'Unknown'}>
        <MdBatteryUnknown
          style={{
            position: 'relative',
            bottom: '-3px'
          }}
          color="#ADADAD"
          size={14}
        />
        <Span style={{ fontSize: '10px' }}>{t('Unknown')}</Span>
      </Span>
      <Span>
        <MdSignalCellularOff
          style={{
            color: '#ADADAD',
            position: 'relative',
            bottom: '-3px'
          }}
          title={'Unknown'}
          size={14}
        />
        <Span style={{ fontSize: '10px' }} ml={2}>
          {t('Unknown')}
        </Span>
      </Span>
    </Flex>
  )
}
const Fa: any = {
  FaBatteryEmpty: {
    batterySymbol: MdBatteryUnknown,
    color: '#ADADAD'
  },
  FaBatteryFull: {
    batterySymbol: MdBatteryFull,
    color: '#279B4E'
  },
  FaBatteryQuarter: {
    batterySymbol: MdBatteryAlert,
    color: '#C84031'
  },
  FaBatteryThreeQuarters: {
    batterySymbol: MdBatteryFull,
    color: '#FDC500'
  }
}

const MdBattery = {
  MdBatteryFull,
  MdBatteryAlert,
  MdBatteryUnknown
}
const MdSignal: any = {
  '#f3f': {
    signalSymbol: MdSignalCellularOff,
    color: '#C84031'
  },
  yellow: {
    signalSymbol: MdSignalCellularConnectedNoInternet4Bar,
    color: '#FDC500'
  },
  cyan: {
    signalSymbol: MdSignalCellular4Bar,
    color: '#279B4E'
  },
  default: {
    signalSymbol: MdSignalCellularOff,
    color: '#ADADAD'
  }
}
const stringtoReactIconName = (name: string) =>
  name
    .split('-')
    .map(item => capitalize(item))
    .join('')

const showFirstWord = (name = '') => name.split(' ')[0]

const displayLastUpdatedAt = (timestamp: any, actualTime: any, t: any) => {
  const timestampHideFlag = timestamp
    ? new Date(timestamp) > subDays(new Date(actualTime?.time), 1)
      ? dateFormatter(timestamp, 'ddMMMhhmmA')
      : '\u00a0'
    : '\u00a0'
  return (
    <Span
      title={timestamp ? dateFormatter(timestamp) : ''}
      variant="secondary"
      style={{ fontSize: '12px', lineHeight: '18px' }}
    >
      {timestampHideFlag}
    </Span>
  )
}

const ColFullHeight = styled((props: any) => (
  <Flex
    p={1}
    justifyContentSpaceEvenly
    column
    {...props}
    style={{
      width: '100%',
      height: '100%',
      padding: '2px 4px',
      ...props.style,
      boxSizing: 'content-box'
    }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`
const Header: any = styled(Span)`
  width: 100%;
  display: block;
  text-transform: uppercase;
  padding: 0 3px;
  text-align: ${({ align = 'left' }: IHeader) => align};
`

function calculateDuplicateAdjacentNode(stops: any) {
  for (var i = 0; stops && i < stops.length - 1; i++) {
    if (
      stops[i].locationCode &&
      stops[i].locationCode == stops[i + 1].locationCode
    ) {
      return true
    }
  }
  return false
}
function generateColumnObject(
  column: IColumn,
  { t, links, queryParams = {} }: any
) {
  const { label, key, formatter, columnConfig } = column
  switch (key) {
    case 'packageId':
      const packageIdWidth = 180
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: packageIdWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const tripRunningStatus: any = getRunningStatusObj(original.etaLapsed)
          const displayTimeCond: Boolean =
            tripRunningStatus &&
            original.etaLapsed != 0 &&
            original.status &&
            !original.status.toLowerCase().includes('untrack') &&
            !original.status.toLowerCase().includes('on time')
          const displayStatus: any = displayTimeCond
            ? `${t(tripRunningStatus.label)} ${t(original.status)}`
            : startCase(t(original.status)) || '-'
          return (
            <ColFullHeight>
              <Link
                target="_blank"
                variant="xs"
                to={`${links.tripShare}/${
                  original.shipmentNo
                }${queryParams.tripShare || ''}`}
                style={{ textDecoration: 'none', display: 'inline-block' }}
              >
                <Flex>
                  {calculateDuplicateAdjacentNode(original.nodes) && (
                    <InfoIcons />
                  )}
                  <BoldText
                    variant="ellipsis h6"
                    style={{
                      color: '#1276D3 !important',
                      fontSize: '14px !important',
                      fontWeight: 'normal',
                      lineHeight: '22px',
                      cursor: 'pointer'
                    }}
                  >
                    {original.shipmentNo}
                  </BoldText>
                </Flex>
              </Link>
              <Flex
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  paddingBottom: '4px'
                }}
              >
                {!!original.inState && (
                  <ColorSpan
                    title={original.inState}
                    variant="secondary"
                    style={{ fontWeight: 600, marginTop: '2px' }}
                  >
                    <GoPrimitiveDot />
                  </ColorSpan>
                )}

                {!!original.inState && t(startCase(original.inState) || '-')}
              </Flex>
              <BgSpan
                variant="h6 ellipsis"
                style={{
                  padding: '2px 4px',
                  borderRadius: 4,
                  fontSize: '10px',
                  lineHeight: '14px'
                }}
                mb={1}
                title={original.status.replace(' ', '') || ''}
                color={'#fff'}
              >
                {displayStatus}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'shipmentId':
      const shipmentIdWidth = 180
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: shipmentIdWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const tripRunningStatus: any = getRunningStatusObj(original.etaLapsed)
          const displayTimeCond: Boolean =
            tripRunningStatus &&
            original.etaLapsed != 0 &&
            original.status &&
            !original.status.toLowerCase().includes('untrack') &&
            !original.status.toLowerCase().includes('on time')
          const displayStatus: any = displayTimeCond
            ? `${t(tripRunningStatus.label)} ${t(original.status)}`
            : startCase(t(original.status)) || '-'
          return (
            <ColFullHeight>
              <Link
                target="_blank"
                variant="xs"
                to={`${links.tripShare}/${
                  original.slug
                }${queryParams.tripShare || ''}`}
                style={{ textDecoration: 'none', display: 'inline-block' }}
              >
                <Flex>
                  {calculateDuplicateAdjacentNode(original.stops) && (
                    <InfoIcons />
                  )}
                  <BoldText
                    variant="ellipsis h6"
                    style={{
                      color: '#1276D3 !important',
                      fontSize: '14px !important',
                      fontWeight: 'normal',
                      lineHeight: '22px',
                      cursor: 'pointer'
                    }}
                  >
                    {original.lrNo}
                  </BoldText>
                </Flex>
              </Link>
              <Flex
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  paddingBottom: '4px'
                }}
              >
                {!!original.inState && (
                  <ColorSpan
                    title={original.inState}
                    variant="secondary"
                    style={{ fontWeight: 600, marginTop: '2px' }}
                  >
                    <GoPrimitiveDot />
                  </ColorSpan>
                )}

                {!!original.inState && t(startCase(original.inState) || '-')}
              </Flex>
              <BgSpan
                variant="h6 ellipsis"
                style={{
                  padding: '2px 4px',
                  borderRadius: 4,
                  fontSize: '10px',
                  lineHeight: '14px'
                }}
                mb={1}
                title={original.status.replace(' ', '') || ''}
                color={'#fff'}
              >
                {displayStatus}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'packageItemCount':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 120,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span>{original.itemQty || '-'}</Span>
          </ColFullHeight>
        )
      }
    case 'shipmentItemCount':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 80,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span>{original.packagesCount || '-'}</Span>
          </ColFullHeight>
        )
      }
    case 'packageStopCount':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 80,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span>
              {original.nodes.length - 1 > 0
                ? `${original.nodes.length - 1}`
                : 0}
            </Span>
          </ColFullHeight>
        )
      }
    case 'modes':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        accessor: 'transportModes',
        width: 130,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight justifyContentCenter>
              <Span variant="ellipsis">
                {original.transportModes
                  ? t(
                      original.transportModes
                        .map((mode: any) => t(mode))
                        .join(' , ')
                    )
                  : '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
    case 'packageTransporterCount':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        accessor: 'transporterNames',
        width: 170,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight justifyContentCenter>
              <Span variant="ellipsis">
                {original.transporterNames
                  ? original.transporterNames.length
                  : '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
    case 'packageRoute':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <MultiModelStoryLine
              story={[
                original.startLocation?.locationName,
                original.endLocation?.locationName
              ]}
              textFontSize="14px"
              noBoldText={true}
            />
            <br />
          </ColFullHeight>
        )
      }
    case 'packageStatus':
      return {
        Header: () => <Header style={{ color: '#727272' }}>{t(label)}</Header>,
        id: key,
        width: 110,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight alignItemsFlexStart>
              <BgSpan
                variant="h6 ellipsis"
                style={{ padding: '3px 5px', borderRadius: 4 }}
                mb={1}
                title={t(original.status.replace(' ', '')) || ''}
                color={'#fff'}
              >
                {t(startCase(original.status)) || '-'}
              </BgSpan>
              {original.exceptionCount ? (
                <Span mb={1} variant="secondary">
                  {t('Exceptions')}:{' '}
                  <BoldText>{original.exceptionCount || 0}</BoldText>
                </Span>
              ) : null}
              {/* <Span mb={1} variant="secondary">
                Delays: <BoldText>{original.delaysCount || '-'}</BoldText>
              </Span> */}
            </ColFullHeight>
          )
        }
      }
    case 'packageCarrier':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const activePackage = original.packageLegs?.find(
            (ele: any) => ele.activeStatus === 'active'
          )
          const Icon = Svg[activePackage?.transportMode]
          return (
            <ColFullHeight>
              <Flex column>
                <Flex
                  alignItemsCenter
                  style={{
                    position: 'relative',
                    top: '5px',
                    paddingBottom: '5px'
                  }}
                >
                  {Icon && (
                    <Icon svgStyle={{ height: '24px', width: '24px' }} />
                  )}
                  <BoldText
                    mb={1}
                    variant="ellipsis"
                    style={{
                      fontSize: '14px !important',
                      fontWeight: 'normal',
                      lineHeight: '22px',
                      marginLeft: '4px'
                    }}
                  >
                    {activePackage?.transporterName}
                  </BoldText>
                </Flex>
                {/* {
                    <Flex style={{ overflow: 'hidden' }}>
                      <Span style={{ margin: '0 5px' }}>
                        {getNameOnTransportMode(activePackage?.transportMode)}
                      </Span>
                      <Span
                        style={{ textTransform: 'uppercase' }}
                        variant="ellipsis"
                      >
                        {activePackage?.vehicleNo || '-'}
                      </Span>
                    </Flex>
                  } */}
                {activePackage?.transportMode === 'ocean' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {activePackage?.vesselNo} - {activePackage?.vesselName}
                    </Span>
                  </Flex>
                )}
                {activePackage?.transportMode === 'road' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {activePackage?.vehicleNo}
                    </Span>
                  </Flex>
                )}
                {activePackage?.transportMode === 'rail' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {activePackage?.vehicleNo}
                    </Span>
                  </Flex>
                )}
                {activePackage?.transportMode === 'air' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {activePackage?.vehicleNo}
                    </Span>
                  </Flex>
                )}
                <Flex>
                  <Span
                    variant="secondary ellipsis"
                    style={{ fontSize: '12px', lineHeight: '18px' }}
                  >
                    {activePackage?.attachRouteString
                      ? toTileCase(activePackage?.attachRouteString)
                      : '-'}
                  </Span>
                  <CarrierPopover transporters={original.packageLegs} />
                </Flex>
              </Flex>
            </ColFullHeight>
          )
        }
      }
    case 'shipmentCarrier':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const Icon = Svg[original?.transportMode]
          return (
            <ColFullHeight>
              <Flex column>
                <Flex
                  alignItemsCenter
                  style={{
                    position: 'relative',
                    top: '5px',
                    paddingBottom: '5px'
                  }}
                >
                  {Icon && (
                    <Icon svgStyle={{ height: '24px', width: '24px' }} />
                  )}
                  <BoldText
                    mb={1}
                    variant="ellipsis"
                    style={{
                      fontSize: '14px !important',
                      fontWeight: 'normal',
                      lineHeight: '22px',
                      marginLeft: '4px'
                    }}
                  >
                    {original?.transporterName}
                  </BoldText>
                </Flex>
                {original.transportMode === 'ocean' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {original?.vesselNo} - {original?.vesselName}
                    </Span>
                  </Flex>
                )}
                {original.transportMode === 'road' && (
                  <Flex alignItemsCenter>
                    {original?.hasMultiVehicle ? (
                      <VehiclePopover
                        currentVehicle={original?.vehicleNo}
                        vehicleData={original?.vehicleData}
                      />
                    ) : (
                      <Span
                        style={{
                          textTransform: 'uppercase',
                          fontSize: '12px',
                          lineHeight: '18px'
                        }}
                        variant="ellipsis"
                      >
                        {original?.vehicleNo}
                      </Span>
                    )}
                  </Flex>
                )}
                {original.transportMode === 'rail' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {original?.vehicleNo}
                    </Span>
                  </Flex>
                )}
                {original.transportMode === 'air' && (
                  <Flex style={{ overflow: 'hidden' }}>
                    <Span
                      style={{
                        textTransform: 'uppercase',
                        fontSize: '12px',
                        lineHeight: '18px'
                      }}
                      variant="ellipsis"
                    >
                      {original?.vehicleNo}
                    </Span>
                  </Flex>
                )}
              </Flex>
            </ColFullHeight>
          )
        }
      }
    case 'packageConsignor':
      const packageConsignorColumnWidth = 130
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: packageConsignorColumnWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Flex column>
              <DropDownPopOver
                list={original.packageConsignorList}
                textToDisplay={toTileCase(original.consignerName) || '-'}
                boldTextStyle={{
                  variant: 'ellipsis h6'
                }}
              />
              <Span
                variant="secondary ellipsis"
                style={{
                  maxWidth: { packageConsignorColumnWidth },
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#212121'
                }}
              >
                {toTileCase(original?.startLocation?.locationName) || '-'}
              </Span>
            </Flex>
          </ColFullHeight>
        )
      }
    case 'packageConsignee':
      const packageConsigneeColumnWidth = 130

      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: packageConsigneeColumnWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <DropDownPopOver
              list={original.packageConsigneeList}
              textToDisplay={toTileCase(original.consigneeName) || '-'}
              boldTextStyle={{
                variant: 'ellipsis h6'
              }}
            />
            <Span
              variant="secondary ellipsis"
              style={{
                maxWidth: packageConsigneeColumnWidth,
                fontSize: '12px',
                lineHeight: '18px',
                color: '#212121'
              }}
            >
              {toTileCase(original?.endLocation?.locationName) || '-'}
            </Span>
            <PoNumberDropDown list={original.poNumberList} />
          </ColFullHeight>
        )
      }
    case 'shipmentConsignor':
      const shipmentConsignorMaxWidth = 145
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: shipmentConsignorMaxWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Flex column>
              <DropDownPopOver
                list={original.shipmentConsignorList}
                textToDisplay={toTileCase(original.consignerName) || '-'}
                boldTextStyle={{
                  variant: 'ellipsis h6'
                }}
              />
              <Span
                variant="secondary ellipsis"
                style={{
                  maxWidth: shipmentConsignorMaxWidth,
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#212121'
                }}
              >
                {toTileCase(original?.startLocation?.locationName) || '-'}
              </Span>
            </Flex>
          </ColFullHeight>
        )
      }
    case 'shipmentConsignee':
      const shipmentConsigneeMaxWidth = 145
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: shipmentConsigneeMaxWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight style={{ alignItems: 'flex-start !important' }}>
            <DropDownPopOver
              list={original.shipmentConsigneeList}
              textToDisplay={toTileCase(original.consigneeName) || '-'}
              boldTextStyle={{
                variant: 'ellipsis h6'
              }}
            />

            <Span
              variant="secondary ellipsis"
              style={{
                maxWidth: shipmentConsigneeMaxWidth,
                fontSize: '12px',
                lineHeight: '18px',
                color: '#212121'
              }}
            >
              {toTileCase(original?.endLocation?.locationName) || '-'}
            </Span>
            <PoNumberDropDown list={original.poNumberList} />
          </ColFullHeight>
        )
      }
    case 'packageNextStop':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 115,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              {!isEmpty(original.nextNode) &&
              original.inState !== 'completed' ? (
                <>
                  <BoldText variant="ellipsis" mb={1}>
                    {toTileCase(original?.nextNode?.name)}
                  </BoldText>
                  <BoldText variant="ellipsis" mb={1}>
                    {original?.nextNode?.eta
                      ? dateFormatter(original?.nextNode?.eta)
                      : null}
                  </BoldText>
                </>
              ) : (
                <>-</>
              )}
            </ColFullHeight>
          )
        }
      }
    case 'shipmentNextStop':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 115,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            {!isEmpty(original.nextStop) && original.inState !== 'completed' ? (
              <>
                <BoldText variant="ellipsis" mb={1}>
                  {toTileCase(original?.nextStop?.name)}
                </BoldText>
                <BoldText variant="ellipsis" mb={1}>
                  {original?.nextStop?.eta
                    ? dateFormatter(original?.nextStop?.eta)
                    : null}
                </BoldText>
              </>
            ) : (
              <>-</>
            )}
          </ColFullHeight>
        )
      }
    case 'currentLandmarkShipment':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const landmarksTemporary = original?.lastLocation?.landmark
          const landmarks = landmarksTemporary
            ? landmarksTemporary.split(',')
            : ['-']
          return (
            <ColFullHeight>
              {
                <LandmarkText
                  title={original?.lastLocation?.landmark}
                  variant="ellipsis"
                  mb={1}
                >
                  {landmarks
                    ?.map((item: string) => toTileCase(item))
                    .join(', ')}
                </LandmarkText>
              }
            </ColFullHeight>
          )
        }
      }
    case 'currentLandmarkPackage':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          const landmarksTemporary =
            original?.latestJourney?.latestLocation?.landmark
          const landmarks = landmarksTemporary
            ? landmarksTemporary.split(',')
            : ['-']
          return (
            <ColFullHeight>
              {
                <LandmarkText
                  title={original?.latestJourney?.latestLocation?.landmark}
                  variant="ellipsis"
                  mb={1}
                >
                  {landmarks
                    ?.map((item: string) => toTileCase(item))
                    .join(', ')}
                </LandmarkText>
              }
            </ColFullHeight>
          )
        }
      }
    case 'packageEquipment':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 200,
        ...columnConfig,
        Cell: ({ row: { original, id } }: any) => {
          const deviceInfo = original?.latestJourney?.deviceInfo
          const trackingProvider = original?.trackingProvider
          const timestamp =
            original?.latestJourney?.latestLocation?.gpsTimestamp
          const issuesRaisedCount = original?.issuesRaisedCount
          const exceptionCount = original?.exceptionCount
          const packageQueryParamsIssueRaised = queryParams.tripShare
            ? `${queryParams.tripShare}&issueRaised=true`
            : `?issueRaised=true`
          const packageQueryParamsExceptionRaised = queryParams.tripShare
            ? `${queryParams.tripShare}&tab=exceptions`
            : `?tab=exceptions`
          const Icon =
            !isEmpty(deviceInfo) &&
            Fa[stringtoReactIconName(deviceInfo?.batteryStrength?.icon)]
              .batterySymbol
          const signalIcon =
            deviceInfo?.signalStrength &&
            deviceInfo?.signalStrength?.color &&
            MdSignal[deviceInfo?.signalStrength?.color]
              ? MdSignal[deviceInfo?.signalStrength?.color]
              : MdSignal['default']
          const SignalIcon = !isEmpty(deviceInfo) && signalIcon.signalSymbol
          return (
            <ColFullHeight>
              <Flex>
                <DeviceDetails
                  id={id}
                  deviceInfo={deviceInfo}
                  t={t}
                  timestamp={timestamp}
                  trackingProvider={trackingProvider}
                  actStartTime={original?.actStartTime}
                />
                <SidePanel
                  issuesRaisedCount={issuesRaisedCount}
                  exceptionCount={exceptionCount}
                  linkToIssueRaised={`${links.tripShare}/${original.shipmentNo}${packageQueryParamsIssueRaised}`}
                  linkToExceptionRaised={`${links.tripShare}/${original.shipmentNo}${packageQueryParamsExceptionRaised}`}
                />
              </Flex>
            </ColFullHeight>
          )
        }
      }
    case 'shipmentEquipment':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 200,
        ...columnConfig,
        Cell: ({ row: { original, id } }: any) => {
          const deviceInfo = original?.deviceInfo
          const temperatureRange = original?.temperatureRange
          const trackingProvider = original?.trackingProvider
          const timestamp = original?.lastLocation?.gpsTimestamp
          const issuesRaisedCount = original?.issuesRaisedCount
          const exceptionCount = original?.exceptionCount
          const shipmentQueryParamsIssueRaised = queryParams.tripShare
            ? `${queryParams.tripShare}&issueRaised=true`
            : `?issueRaised=true`
          const shipmentQueryParamsExceptionRaised = queryParams.tripShare
            ? `${queryParams.tripShare}&tab=exceptions`
            : `?tab=exceptions`
          return (
            <ColFullHeight>
              <Flex>
                <DeviceDetails
                  id={id}
                  deviceInfo={deviceInfo}
                  temperatureRange={temperatureRange}
                  t={t}
                  timestamp={timestamp}
                  trackingProvider={trackingProvider}
                  actStartTime={original?.actStartTime}
                />
                <SidePanel
                  issuesRaisedCount={issuesRaisedCount}
                  exceptionCount={exceptionCount}
                  linkToIssueRaised={`${links.tripShare}/${original.slug}${shipmentQueryParamsIssueRaised}`}
                  linkToExceptionRaised={`${links.tripShare}/${original.slug}${shipmentQueryParamsExceptionRaised}`}
                />
              </Flex>
            </ColFullHeight>
          )
        }
      }
    case 'status':
      return {
        Header: () => <Header style={{ color: '#727272' }}>{t(label)}</Header>,
        id: key,
        width: 120,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <BgSpan
                title={t(original.status.replace(' ', ''))}
                variant="h6"
                style={{ padding: '3px 5px', borderRadius: '6px' }}
                color={'#ffff'}
              >
                {original.status ? t(startCase(original.status)) : '-'}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'inState':
      return {
        Header: () => <Header style={{ color: '#727272' }}>{t(label)}</Header>,
        id: key,
        width: 120,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <BgSpan
                title={t(original.inState.replace(' ', ''))}
                variant="h6"
                style={{ padding: '2px 10px', borderRadius: '6px' }}
                color={'#ffff'}
              >
                {original.inState ? t(startCase(original.inState)) : '-'}
              </BgSpan>
            </ColFullHeight>
          )
        }
      }
    case 'stopCount':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 90,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span variant="ellipsis">
              {t(original.stops?.length - 1) || '-'}
            </Span>
          </ColFullHeight>
        )
      }
    case 'shipmentIdList':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 160,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span variant="ellipsis">
              <Link
                target="_blank"
                variant="xs"
                to={`${links.tripShare}/${
                  original.slug
                }${queryParams.tripShare || ''}`}
              >
                {(original.lrNo)}
              </Link>
            </Span>
          </ColFullHeight>
        )
      }
    case 'packageIdList':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 130,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <Span variant="ellipsis">
              <Link
                target="_blank"
                variant="xs"
                title={original.shipmentNo}
                to={`${links.tripShare}/${
                  original.shipmentNo
                }${queryParams.tripShare || ''}`}
              >
                {original.shipmentNo}
              </Link>
            </Span>
          </ColFullHeight>
        )
      }
    case 'currentTemperature':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let data = original?.deviceInfo?.extraData || {}
          let value =
            isEmpty(data) ||
            !(
              data?.hasOwnProperty('temperature') ||
              data?.hasOwnProperty('sensorData')
            )
              ? null
              : parseTemperature(
                  original?.deviceInfo?.extraData?.temperature ??
                    original?.deviceInfo?.extraData?.sensorData
                )
          return (
            <ColFullHeight>
              {value ? <Span variant="ellipsis">{value}&#8451;</Span> : <>-</>}
            </ColFullHeight>
          )
        }
      }
    case 'temperatureRange':
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 160,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let data = original?.temperatureRange
          let value =
            data?.temperatureMax !== null && data?.temperatureMin !== null
              ? [data?.temperatureMin, data?.temperatureMax]
              : []
          return (
            <ColFullHeight>
              {!isEmpty(value) ? (
                <Span variant="ellipsis">
                  {parseTemperature(value[0])}&#8451; {t('to')}{' '}
                  {parseTemperature(value[1])}&#8451;
                </Span>
              ) : (
                <>-</>
              )}
            </ColFullHeight>
          )
        }
      }
    case 'containerNo': 
      const containerIdWidth = 180
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: containerIdWidth,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <Link
                target="_blank"
                variant="xs"
                to={`${links.tripShare}/${
                  original.containerNo
                }${queryParams.tripShare || ''}`}
                style={{ textDecoration: 'none', display: 'inline-block' }}
              >
                <Flex>
                  <BoldText
                    variant="ellipsis h6"
                    style={{
                      color: '#1276D3 !important',
                      fontSize: '14px !important',
                      fontWeight: 'normal',
                      lineHeight: '22px',
                      cursor: 'pointer'
                    }}
                  >
                    {original.containerNo}
                  </BoldText>
                </Flex>
              </Link>
            </ColFullHeight>
          )
        }
      }

    default:
      return {
        Header: () => (
          <Header data-id={key} style={{ color: '#727272' }}>
            {t(label)}
          </Header>
        ),
        id: key,
        width: 140,
        ...columnConfig,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight>
              <Span variant="ellipsis">
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumn[],
  { t, links, queryParams = {} }: any
) {
  const result: any = []
  //status and next stop columns are added until config for users cannot be updated
  //because of design change and design is partially at mobi and partially at staging but not on production
  //when this code is merged everywhere with config update mobi+staging+production these columns can be removed.
  reqdColumns.map(ele => {
    if (
      ele.key &&
      ![
        'expand',
        'expandHide',
        'packageNextStop',
        'packageStatus',
        'shipmentNextStop'
      ].includes(ele.key)
    ) {
      result.push(generateColumnObject(ele, { t, links, queryParams }))
    }
  })
  return result
}
